var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "view_cont" }, [
              _c("table", { staticClass: "data_table" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(this.popupType))]),
                    _vm._v(" "),
                    _c("th", [_vm._v("View")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("User")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  { staticClass: "text_center" },
                  _vm._l(_vm.tableData, function(data, index) {
                    return _c("tr", { key: index }, [
                      _c("td", { attrs: { align: "left" } }, [
                        _vm._v(_vm._s(data.NAME))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(data.CNT))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(data.USER_CNT))])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn_wrap topLine" }, [
                _c("div", { staticClass: "btn_right" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn_white",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CLOSE")))]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "ellipsis maintit" }, [
      _c("i", [_vm._v("User")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f474d53e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f474d53e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/statisticsManager/UsagePopVue.vue
// module id = Nli1
// module chunks = 0